import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { CCOButton, CCOAlert } from '../util/Components.js';
import {clone, push, update} from '../util/Utility.js';

class PanelEditView extends Component {

  constructor(props) {
    super(props);

    this.state = {
      networkAlert: false
    }
  }

  save() {
    console.log("saving object");
    var parent = this;
    let type = this.props.subtype || this.props.type;
    this.props.saveCheck().then(object => {
      if (parent.props.new) {
        push(type + 's', this, object).then(function(newObj) {
          parent.dismissAlerts();
          parent.props.done({object: newObj});
          this.props.setState({object: clone(parent.props.defaultObject)});
        }.bind(this)).catch(function() {
          this.setState({networkAlert: true});
        }.bind(this));
      } else {
        parent.dismissAlerts();
        parent.props.done({object: object});
        update(type + 's/' + parent.props.object.key, this, object).catch(function(error) {
          console.log(error);
          this.setState({networkAlert: true});
        }.bind(this));
      }
    });

  }

  dismissAlerts() {
    this.props.dismissAlerts();
    this.setState({networkAlert: false});
  }

  cancel() {
    if (this.props.new) {
      this.props.setState({object: clone(this.defaultObject)});
    }
    this.dismissAlerts();
    this.props.done({object: null});
  }

  render() {

    var divStyle = {
      maxWidth: 500,
      color: 'black'
    };
    
    return (
      <div style={divStyle}>
        <Modal show={this.props.show}>
          <Modal.Header>
            <Modal.Title>{this.props.new ? "New " + this.props.title : "Edit " + this.props.title}</Modal.Title>
          </Modal.Header>

          <Modal.Body>

            {this.props.children}

            <div style={{height: 10}} />
            <CCOAlert in={this.state.networkAlert} type="warning" title="Network Error" content="Could not save because we could not connect to the server, please try again later." />

          </Modal.Body>

          <Modal.Footer>
            <center>
              <div style={{width: 200}}>
                <CCOButton onClick={this.save.bind(this)} text={this.props.saveButtonTitle || (this.props.new ? "Save" : "Save Changes")} type="primary" />
              </div>
              <div style={{height: 2}} />
              <button className="blueButton" type="button" onClick={this.cancel.bind(this)}>Cancel</button>
            </center>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default PanelEditView;



/** WEBPACK FOOTER **
 ** ./src/model/PanelEditView.js
 **/